/**
 * Canonical font definitions for account theming.
 *
 * `BASE_FONT_OPTIONS` (UI labels) lives here because it is authoring-specific.
 * The built-in family set, sentinel, and helpers are re-exported from
 * @course-authoring/shared-types so the export player shares the same set.
 */

// Re-export shared font utilities for backward compatibility.
export {
  BASE_FONT_FAMILIES,
  CUSTOM_FONT_SENTINEL,
  isBuiltInFontFamily,
} from '@course-authoring/shared-types';

export interface FontOption {
  value: string;
  label: string;
  family: string;
}

export const BASE_FONT_OPTIONS: FontOption[] = [
  {
    value: 'source-sans-pro',
    label: 'Source Sans Pro (default)',
    family: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
  },
  { value: 'georgia', label: 'Georgia', family: 'Georgia, serif' },
  { value: 'times-new-roman', label: 'Times New Roman', family: '"Times New Roman", Times, serif' },
  { value: 'trebuchet-ms', label: 'Trebuchet MS', family: '"Trebuchet MS", sans-serif' },
  { value: 'verdana', label: 'Verdana', family: 'Verdana, sans-serif' },
  { value: 'courier-new', label: 'Courier New', family: '"Courier New", Courier, monospace' },
];

/** Returns `storedFont` when it is a known built-in family, otherwise `fallback`. */
export function resolveBuiltInFontFamily(storedFont: string | null, fallback: string): string {
  const families: string[] = BASE_FONT_OPTIONS.map((option) => option.family);
  return typeof storedFont === 'string' && families.includes(storedFont) ? storedFont : fallback;
}
